import styled from '@emotion/styled';
import { RotateCw } from 'lucide-react';
import { useMemo } from 'react';
import { AUTO_KIT_TYPE, resolveTeamColors } from 'shared/kit/resolve-team-color';
import { theme } from 'styles/theme/theme';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import Block from '../components/block';
import { Separator } from '../components/separator';
import Text from '../components/text';

export function TeamsName() {
  const { teams } = useGameInfo();

  // Комплект по правилу `auto`: команда №1 играет в домашней форме, №2 — в гостевой.
  const firstColors = useMemo(
    () => resolveTeamColors(teams?.first.kits, { teamIndex: 0, kitType: AUTO_KIT_TYPE }),
    [teams?.first.kits],
  );
  const secondColors = useMemo(
    () => resolveTeamColors(teams?.second.kits, { teamIndex: 1, kitType: AUTO_KIT_TYPE }),
    [teams?.second.kits],
  );

  return (
    <div className={'flex'}>
      <Separator colorDown={firstColors.primary} colorUp={firstColors.secondary} />
      <Block className={'flex-center'} style={{ gap: 4, height: 60, width: '100%', paddingInline: 8 }}>
        <TeamName className={'flex-center'}>
          <Text color={theme.colors.SurfaceWhite} size={'large'} style={{ maxWidth: '100%' }}>
            {teams?.first.name}
          </Text>
        </TeamName>
        <RotateCw size={16} color={theme.colors.WhiteGray} />
        <TeamName className={'flex-center'}>
          <Text color={theme.colors.SurfaceWhite} size={'large'} style={{ maxWidth: '100%' }}>
            {teams?.second.name}
          </Text>
        </TeamName>
      </Block>
      <Separator colorDown={secondColors.primary} colorUp={secondColors.secondary} />
    </div>
  );
}

const TeamName = styled.div`
  flex-grow: 48;
  flex-basis: 0;
  overflow: hidden;
  max-width: 100%;
`;
